import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import accessDenied from './Routes/AccessDenied';
import conectores from './Routes/Conectores';
import analiseDesempenho from './Routes/AnaliseDesempenho';
import indicadores from './Routes/Indicadores';
import home from './Routes/Home';
import login from './Routes/Login';
import logout from './Routes/Logout';
import notFound from './Routes/NotFound';
import redirect from './Routes/Redirect';
import Route from './Routes';

export default [
  ...accessDenied,
  ...home,
  ...conectores,
  ...indicadores,
  ...analiseDesempenho,
  ...login,
  ...logout,
  ...notFound,
  ...redirect,
];

export const Routes = ({ routes }) => (
  <Router>
    <Switch>
      {routes
        .filter((item) => item.component)
        .map((route, index) => (
          <Route key={route.path || index} {...route} />
        ))}
    </Switch>
  </Router>
);
